<template>
   <div class="calculate-tax">
        <title-screen title ="3"></title-screen>
        <el-form ref="form" :model="form" class="form" :rules="rules">
           <table class="table">
               <tr>
                   <th id="land" class="column-label">土地</th>
                   <td class="column-input">
                       <Money :min='0' :max='9999' :fixed='0' class="input" @input="sumJudgmentRequired" v-model="form.tochiOku" clearable></Money>億
                       <Money :min='0' :max='9999' :fixed='0' class="input2 ml1" @input="sumJudgmentRequired" v-model="form.tochiMan" clearable></Money>万円
                   </td>
               </tr>
               <tr>
                   <th id="number-of-land" class="column-label">土地の数</th>
                   <td class="column-input">
                       <el-select v-model="form.numberOfLand" placeholder="選択してください" @change="function() {
                         totalYen();
                       }" onselect="">
                           <el-option
                                   v-for="item in calcLandCount"
                                   :key="item.itemKey"
                                   :label="item.itemValue"
                                   :value="item.itemKey">
                           </el-option>
                       </el-select>
                   </td>
               </tr>
               <tr>
                   <th id="house" class="column-label">家屋</th>
                   <td class="column-input">
                       <Money :min='0' :max='9999' :fixed='0' class="input" @input="sumJudgmentRequired" v-model="form.kaokuOku" clearable></Money>億
                       <Money :min='0' :max='9999' :fixed='0' class="input2 ml1" @input="sumJudgmentRequired" v-model="form.kaokuMan" clearable></Money>万円
                   </td>
               </tr>
               <tr>
                   <th id="securities" class="column-label">有価証券</th>
                   <td class="column-input">
                       <Money :min='0' :max='9999' :fixed='0' class="input" @input="sumJudgmentRequired" v-model="form.yochokinOku" clearable></Money>億
                       <Money :min='0' :max='9999' :fixed='0' class="input2 ml1" @input="sumJudgmentRequired" v-model="form.yochokinMan" clearable></Money>万円
                   </td>
               </tr>
               <tr>
                   <th id="number-of-shares" class="column-label">非上場株式の有無</th>
                   <td class="column-input">
                       <el-radio-group v-model="form.numberOfUnlistedShares" @change="totalYen">
                           <el-radio :key="57001" :label="1" class="mr1">あり</el-radio>
                           <el-radio :key="57002" :label="0" class="mr1">なし</el-radio>
                       </el-radio-group>
                   </td>
               </tr>

               <tr>
                   <th id="deposit-and-savings" class="column-label">預貯金</th>
                   <td class="column-input">
                       <Money :min='0' :max='9999' :fixed='0' class="input" @input="sumJudgmentRequired" v-model="form.yuukaSyoukenOku" clearable></Money>億
                       <Money :min='0' :max='9999' :fixed='0' class="input2 ml1" @input="sumJudgmentRequired" v-model="form.yuukaSyoukenMan" clearable></Money>万円
                   </td>
               </tr>

               <tr>
                   <th id="number-of-branches" class="column-label">預金口座のある支店数</th>
                   <td class="column-input">
                       <el-form-item prop="branchesNumber">
                        <el-input class="input-legal-heir" @input="convertStrAndSumJudgmentRequiredBranchesNumber" v-model="form.branchesNumber"></el-input>支店
                       </el-form-item>
                   </td>
               </tr>

               <tr>
                   <th id="other" class="column-label">その他</th>
                   <td class="column-input">
                       <Money :min='0' :max='9999' :fixed='0' class="input" @input="sumJudgmentRequired" v-model="form.sonotaOku" clearable></Money>億
                       <Money :min='0' :max='9999' :fixed='0' class="input2 ml1" @input="sumJudgmentRequired" v-model="form.sonotaMan" clearable></Money>万円
                   </td>
               </tr>
               <tr>
                   <th id="debt" class="column-label">債務</th>
                   <td class="column-input">
                       <Money :min='0' :max='9999' :fixed='0' class="input" @input="sumJudgmentRequired" v-model="form.saimuOku" clearable></Money>億
                       <Money :min='0' :max='9999' :fixed='0' class="input2 ml1" @input="sumJudgmentRequired" v-model="form.saimuMan" clearable></Money>万円
                   </td>
               </tr>
               <tr>
                   <th id="the-amount" class="column-label calculator-text-color">総額</th>
                   <td class="column-input">
                       <div class="lbl-bill"><span class="calculator-text-color calculator-font-size">{{showYen}}</span> 万円</div>
                       <div class="lbl-yen"><span class="calculator-text-color calculator-font-size">{{form.billion01}}</span> 億</div>
                   </td>
               </tr>

               <tr>
                   <th id="number-of-legal" class="column-label">法定相続人の数</th>
                   <td class="column-input">
                       <el-form-item prop="legalHeir">
                           <el-input class="input-legal-heir" @input="convertStrAndSumJudgmentRequired" v-model="form.legalHeir"></el-input> 人
                       </el-form-item>
                   </td>
               </tr>
               <tr>
                   <th id="marital-status" class="column-label">配偶者の有無</th>
                   <td class="column-input">
                       <el-radio-group v-model="form.maritalStatus" @change="changType" :disabled="disableMaritalStatus">
                           <el-radio v-for="item in calcSpouse"
                                     :key="item.itemKey"
                                     :label="item.itemKey"
                                     class="mr1">{{item.itemValue}}</el-radio>
                       </el-radio-group>
                   </td>
               </tr>
               <tr>
                   <th id="ratio-of-spouses" class="column-label">配偶者の遺産取得割合</th>
                   <td class="column-input">
                       <el-select v-model="form.acquisitionRatio" @change="sumJudgmentRequired" placeholder="選択してください" class="select2" :disabled="disabledRatio">
                           <el-option
                                   v-for="item in calcRatio"
                                   :key="item.itemKey"
                                   :label="item.itemValue"
                                   :value="item.itemValue">
                           </el-option>
                       </el-select>
                       %
                   </td>
               </tr>
               <tr>
                   <th id="relationship-of-legal" class="column-label">配偶者以外の法定相続人の続柄</th>
                   <td class="column-input">
                       <el-radio-group v-model="form.type"  @change="sumJudgmentRequired" :disabled="disabledType">
                           <el-radio
                                   v-for="item in calcRelation"
                                   :key="item.itemKey"
                                   :label="item.itemKey">{{item.itemValue}}</el-radio>
                       </el-radio-group>
                   </td>
               </tr>
               <tr style="height: 20px"></tr>
               <tr>
                   <td colspan="2" class="box-calculation">
                       <div v-if="showDataCompute">
                           <span>
                               <b>相続税の申告は</b><span class="text-necessary">{{necessary}}</span><b>です。</b>
                           </span>
                           <hr>
                           <p>
                               <span class="title">相続税は、</span>
                               <el-input v-model="form.billionRequired" disabled class="w-50-percent input-21-red"></el-input><span class="ml-5px mr2">億</span>
                               <el-input v-model="form.yenRequired" disabled class="w-50-percent input-21-red"></el-input><span class="ml-5px">万となります。</span>
                           </p>
                       </div>
                       <hr>
                       <div class="box-submit-form">
                           <div style="text-align: left; color: #cc0000; font-weight: normal">
                               <span>
                               小規模宅地の評価減等の特例があるため、詳細は面談相談の際にお伝えください。<br/>
                                申告することでゼロになるケースもあります。
                           </span>
                           </div>
                           <hr>
                           <div style="text-align: left">
                               <span style="font-size: 18px">※注意事項</span>
                               <ul style="font-weight: normal; list-style: inherit; padding-left: 20px">
                                   <li style="list-style: inherit">現行の税制（2015年1月1日以降に相続が発生された方）をもとに自動計算した金額で、あくまでも目安の金額となります。</li>
                                   <li style="list-style: inherit">遺産総額の金額は、各種特例や非課税枠及び債務控除等を控除済みの課税価格 （基礎控除前）の金額を入力してください。</li>
                                   <li style="list-style: inherit">上記金額には小規模宅地の評価減等の特例は考慮しておりません。特例を含めた詳細についてはご面談でご案内いたします。（ご面談は予約制となります。ご面談予約はお問い合わせフォームよりお問い合わせください）</li>
                                   <li style="list-style: inherit">配偶者が取得する財産については申告によって適用出来る軽減措置があるため、相続税が発生しない場合でも申告が必要となる場合がございます。</li>
                               </ul>
                           </div>
                           <hr class="hr-estimation">
                           <p class="estimation-explain" v-show="!showTotal">
                               専門家に依頼する場合のお見積額を知りたい方はボタンをクリック
                           </p>
                           <p class="money-than" v-show="showTotal && isOverEstimate" v-html="moneyThan500Hyaku"></p>
                           <div v-show="showTotal && !isOverEstimate">
                               <div v-if="necessary === '不要'" class="money-than">相続税申告が不要な場合は<mark style="font-size: 22px; color: #a5272a; background-color: unset ">個別見積</mark>となりますので、<br/>以下よりお問い合わせください</div>
                               <div v-else><span>見積額合計</span> <span class="total">{{form.estimateSum}}</span>円  （税抜）<br/>
                                   税込 <span class="total-with-tax">{{form.estimeteSumWithTax}}</span> 円<br />
                                   上記金額は概算です。詳細なお見積もりをご希望の方は、以下よりお問い合わせください。<br />
                                   <p v-if="form.numberOfUnlistedShares">※非上場株式評価の報酬は別途見積となり、上記報酬には含まれていません。</p>
                               </div>
                           </div>
                            <el-button class="el-button-big gtm_rosenka_quote" v-if="!showTotal" @click="handleCompute" :disabled="disabledEstimateButton" ><span class="gtm_rosenka_quote">お見積もりはこちら</span></el-button>
                            <el-button class="el-button-big gtm_kantan_toiawase_k" v-else @click="redirectContact" style="background: #f39800 !important; margin-top: 1em;"><span class="gtm_kantan_toiawase_k">お問い合わせはこちら</span></el-button>
                           <div style="text-align: left; margin-top: 10px" v-show="showTotal">
                               <span style="font-size: 18px">＜加算報酬について＞</span>
                               <ul style="font-weight: normal; list-style: inherit; padding-left: 20px">
                                   <li style="list-style: inherit">相続人2人目より1人あたり基本報酬×10%の金額を加算します。当該加算については4人を上限とします。</li>
                                   <li style="list-style: inherit">土地最初の1利用単位につき8万円（税込8.8万円）、2利用単位目以降１利用単位につき6万円（税込6.6万円）を加算します。</li>
                                   <li style="list-style: inherit">預金口座のある1支店につき2万円（税込2.2万円）を加算します。</li>
                                   <li style="list-style: inherit">非上場株式を所有している場合には、会社規模により別途見積金額を加算します。</li>
                                   <li style="list-style: inherit">お客様の御要望により生じる上記以外の業務については別途ご案内します。</li>
                               </ul>
                           </div>
                       </div>
                   </td>
               </tr>
           </table>
       </el-form>
      <member-note :type="noteType" :gtm_class="gtmClass" v-if="isAuthenticated"></member-note>
   </div>
</template>
<script>
import { mapGetters } from 'vuex'
import calculationtax from '@/api/calculationtax/calculation-cl.js'
import Money from '@/components/money/Money'
import TitleScreen from '@/components/common/TitleScreen'
import MemberNote from '@/components/common/MemberNote'
import { NOTE_TYPE } from '../../../../common/constance'
import { isIE } from '@/common/useragent'

export default {
    data () {
        const validateLegalHeir = (rule, value, callback) => {
            if (!this.form.legalHeir) {
                callback(new Error('法定相続人の数を入力してください'))
            } else {
                callback()
            }
        }
        return {
            form: {
                billion01: '0',
                yen01: '0',
                tochiOku: '',
                tochiMan: '',
                kaokuOku: '',
                kaokuMan: '',
                yochokinOku: '',
                yochokinMan: '',
                yuukaSyoukenOku: '',
                yuukaSyoukenMan: '',
                sonotaOku: '',
                sonotaMan: '',
                saimuOku: '',
                saimuMan: '',
                legalHeir: '',
                maritalStatus: '60002',
                acquisitionRatio: '',
                numberOfLand: '',
                numberOfUnlistedShares: 0,
                type: '59001',
                billionRequired: 0,
                yenRequired: 0,
                estimateSum: 0,
                estimeteSumWithTax: 0,
                branchesNumber: ''
            },
            rules: {
                legalHeir: [
                    { validator: validateLegalHeir, trigger: 'blur' }
                ]
            },
            calcLandCount: [],
            calcNonStockCount: [],
            calcSpouse: [],
            calcRatio: [],
            calcRelation: [],
            memberId: '',
            idUpdate: 0,
            showTotal: false,
            showQuote: true,
            disabledCalcRelation: false,
            necessary: '不要',
            estimatesAddDtoPrivate: [],
            estimatesBaseDtoPrivate: [],
            dialogVisible: false,
            originOku: 0,
            originMan: 0,
            isScrollDown: false,
            isDataExist: false,
            isClickBtnSave: false,
            noteType: NOTE_TYPE.TAX_CALCULATION,
            moneyThan500Hyaku: '5億円超の方は<mark style="font-size: 22px; color: #a5272a; background-color: unset ">個別見積もり</mark>となりますので、<br>以下よりお問い合わせください。',
            showMsgTotal: false,
            legalHeirError: false,
            totalText: '',
            gtmClass: 'gtm_kantan_memo_k'
        }
    },
    components: {
      'Money': Money,
      'title-screen': TitleScreen,
      'member-note': MemberNote
    },
    computed: {
    ...mapGetters(['currentUser', 'isAuthenticated']),
      isOverEstimate: function () {
        return (this.originOku + this.originMan / 10000) > 5
      },
      disabledRatio: function () {
        return !(this.form.maritalStatus === '60001' && this.form.legalHeir >= 2)
      },
      disabledType: function () {
        if (Number(this.form.legalHeir) === 0) {
            return true
        } else {
            return parseInt(this.form.legalHeir) === 1 && this.form.maritalStatus === '60001'
        }
      },
      showDataCompute: function () {
          return this.form.legalHeir
      },
      showYen: function () {
          if (parseInt(this.form.yen01) < 0 && parseInt(this.form.billion01) < 0) { return Math.abs(this.form.yen01) }
          return this.form.yen01
      },
      disabledEstimateButton: function () {
        if (this.form.legalHeir) {
            return false
        } else {
            return true
        }
      },
      disableMaritalStatus: function () {
        return Number(this.form.legalHeir) === 0
      }
    },
    methods: {
        formatPrice (value) {
            let val = (value / 1).toFixed(0).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },
        deformatPrice (value) {
            return value.replace(/,/g, '')
        },
        async getItemData () {
            await calculationtax.getItemData().then(response => {
                if (response.data.data.calc_spouse.value.length > 0) {
                    this.calcSpouse = response.data.data.calc_spouse.value
                }
                if (response.data.data.calc_ratio.value.length > 0) {
                    this.calcRatio = response.data.data.calc_ratio.value
                }
                if (response.data.data.calc_relation.value.length > 0) {
                    this.calcRelation = response.data.data.calc_relation.value
                }
            })
            await calculationtax.getInformEstimates().then(response => {
                let _this = this
                this.estimatesAddDtoPrivate = response.data.data.estimatesAddDTOList
                this.estimatesBaseDtoPrivate = response.data.data.estimatesBaseDTOList
                let estimatesAddDtoList = response.data.data.estimatesAddDTOList
                this.calcLandCount = []
                if (response.data.data.estimatesAddDTOList.length > 0) {
                    estimatesAddDtoList.forEach(function (item, index) {
                        if (item.categoryType === 'land') {
                            _this.calcLandCount.push({ 'id': item.id, 'itemKey': item.quantity, 'itemValue': item.categoryName, 'categoryType': item.categoryType, 'reward': item.reward })
                        }
                    })
                }
            })
        },
        registerData () {
            let billion02 = this.getDataInputText(this.form.tochiOku)
            let billion03 = this.getDataInputText(this.form.kaokuOku)
            let billion04 = this.getDataInputText(this.form.yochokinOku)
            let billion05 = this.getDataInputText(this.form.yuukaSyoukenOku)
            let billion06 = this.getDataInputText(this.form.sonotaOku)
            let billion07 = this.getDataInputText(this.form.saimuOku)
            let yen02 = this.getDataInputText(this.form.tochiMan)
            let yen03 = this.getDataInputText(this.form.kaokuMan)
            let yen04 = this.getDataInputText(this.form.yochokinMan)
            let yen05 = this.getDataInputText(this.form.yuukaSyoukenMan)
            let yen06 = this.getDataInputText(this.form.sonotaMan)
            let yen07 = this.getDataInputText(this.form.saimuMan)

            let numberOfLand = this.form.numberOfLand
            let numberOfUnlistedShares = this.form.numberOfUnlistedShares
            let type = []
            if (this.form.type.length > 0) {
                type = this.form.type
            }
            let memberId = this.memberId
            let land = (billion02 * 10000) + yen02
            let landCount = '0'
            if (numberOfLand > 0) {
                landCount = numberOfLand
            }
            let house = (billion03 * 10000) + yen03
            let stocks = (billion04 * 10000) + yen04
            let nonStockCount = '0'
            if (numberOfUnlistedShares > 0) {
                nonStockCount = numberOfUnlistedShares
            }
            let savings = (billion05 * 10000) + yen05
            let etc = (billion06 * 10000) + yen06
            let debt = (billion07 * 10000) + yen07
            let heirsNumber = '0'
            if (this.form.legalHeir > 0) {
                heirsNumber = this.form.legalHeir
            }
            let maritalStatus = '0'
            if (this.form.maritalStatus > 0) {
                maritalStatus = this.form.maritalStatus
            }
            let acquisitionRatio = '0'
            if (this.form.acquisitionRatio > 0) {
                acquisitionRatio = this.form.acquisitionRatio.trim()
            }
            let relationship = type.toString()
            let branchesNumber = '0'
            if (this.form.branchesNumber > 0) {
                branchesNumber = this.form.branchesNumber
            }
            let data = {
                'id': this.idUpdate,
                'memberId': memberId,
                'land': land,
                'landCount': landCount,
                'house': house,
                'stocks': stocks,
                'nonStockCount': nonStockCount,
                'savings': savings,
                'etc': etc,
                'debt': debt,
                'heirsNumber': heirsNumber,
                'maritalStatus': maritalStatus,
                'acquisitionRatio': acquisitionRatio,
                'relationship': relationship,
                'branchesNumber': branchesNumber
            }
            if (memberId !== undefined && memberId !== '') {
                calculationtax.createTaxCal(data).then(response => {
                    this.isDataExist = true
                })
            }
        },
        openDialog (msg) {
            this.$alert(msg, '判定', {
                dangerouslyUseHTMLString: true
            })
        },
        parseInt (value) {
            let parseValue = parseInt(value)
            return parseValue === 0 ? '' : parseValue
        },
        async showDataTax () {
            let memberId = this.currentUser.id
            if (memberId !== undefined) {
                await this.getItemData()
                calculationtax.getInformTaxCal(memberId).then(response => {
                    if (response.data.data.id !== null && response.data.data.memberId !== null) {
                        this.idUpdate = this.parseInt(response.data.data.id)
                        this.form.tochiOku = this.parseInt(response.data.data.land01)
                        this.form.kaokuOku = this.parseInt(response.data.data.house01)
                        this.form.yochokinOku = this.parseInt(response.data.data.stocks01)
                        this.form.yuukaSyoukenOku = this.parseInt(response.data.data.savings01)
                        this.form.sonotaOku = this.parseInt(response.data.data.etc01)
                        this.form.saimuOku = this.parseInt(response.data.data.debt01)
                        this.form.tochiMan = this.parseInt(response.data.data.land02)
                        this.form.kaokuMan = this.parseInt(response.data.data.house02)
                        this.form.yochokinMan = this.parseInt(response.data.data.stocks02)
                        this.form.yuukaSyoukenMan = this.parseInt(response.data.data.savings02)
                        this.form.sonotaMan = this.parseInt(response.data.data.etc02)
                        this.form.saimuMan = this.parseInt(response.data.data.debt02)
                        this.form.numberOfLand = this.parseInt(response.data.data.landCount)
                        this.form.numberOfUnlistedShares = (this.parseInt(response.data.data.nonStockCount) > 0) ? 1 : 0
                        this.form.legalHeir = this.parseInt(response.data.data.heirsNumber)
                        this.form.maritalStatus = response.data.data.maritalStatus
                        this.form.acquisitionRatio = response.data.data.acquisitionRatio
                        this.form.branchesNumber = this.parseInt(response.data.data.branchesNumber)
                        let rela = response.data.data.relationship
                        let type = []
                        if (rela.length > 0) {
                            if (rela.indexOf(',') > 0) {
                                type = response.data.data.relationship.split(',')
                            } else {
                                type = response.data.data.relationship
                            }
                        }
                        this.form.type = type
                        this.sumJudgmentRequired()
                        this.isDataExist = true
                    }
                })
            }
        },
        getLandCountValue (val) {
            let numberOfLand = ''
            this.calcLandCount.forEach(function (item) {
                if (item.itemKey === val) {
                    numberOfLand = item.itemValue
                }
            })
            return numberOfLand
        },
        getNonStockCountValue (val) {
            let numberOfLand = ''
            this.calcNonStockCount.forEach(function (item) {
                if (item.itemKey === val) {
                    numberOfLand = item.itemValue
                }
            })
            return numberOfLand
        },
        fetchData () {
            this.memberId = this.currentUser === null ? null : this.currentUser.id
            if (this.memberId !== undefined || this.memberId !== '') {
                this.showDataTax()
            }
        },
        calculionJudgment () {
            this.submitForm()
            this.showTotal = false

            if (Number.isNaN(this.form.legalHeir)) {
                this.dialogVisible = true
            } else {
                this.dialogVisible = false
                this.isClickBtnSave = true
                this.showTotal = true
                this.isScrollDown = true
                this.sumJudgmentRequired()
                this.registerData()
                this.isClickBtnSave = false
            }
        },
        submitForm () {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    return true
                } else {
                    return false
                }
            })
        },
        redirectContact () {
            let routeData = this.$router.resolve({ name: 'contact' })
            window.open(routeData.href, '_blank')
        },
        disableLegalHeir () {
            let legalHeir = this.form.legalHeir
            if (legalHeir === 1) {
                this.disableLegalHeirIsOne()
            } else if (legalHeir === 0) {
                this.disableLegalHeirIsRezo()
            } else if (legalHeir > 1) {
                this.disableLegalHeirIsNotOne()
            }
        },
        disableLegalHeirIsOne () {
            let maritalStatus = this.form.maritalStatus
            if (maritalStatus === '60001') {
                this.disabledType = true
                this.disabledRatio = true
            } else {
                this.disabledType = false
                this.disabledRatio = true
            }
        },
        disableLegalHeirIsRezo () {
            let maritalStatus = this.form.maritalStatus
            this.disabledRatio = true
            if (maritalStatus === '60001') {
                this.disabledType = true
            } else {
                this.disabledType = false
            }
        },
        disableLegalHeirIsNotOne () {
            let maritalStatus = this.form.maritalStatus
            if (maritalStatus === '60001') {
                this.disabledType = false
                this.disabledRatio = false
            } else {
                this.disabledType = false
                this.disabledRatio = true
            }
        },
        getDataInputText (val) {
             let data = 0
            if (parseInt(val)) {
                data = parseInt(val)
            } else if (parseInt(val) === 0) {
                data = 0
            } else {
                data = 0
            }
            return data
        },
        sumJudgmentRequired () {
            this.showTotal = false
            let legalHeirform = this.form.legalHeir
            if (legalHeirform === '') {
                legalHeirform = 0
            }
            let legalHeir = parseInt(legalHeirform)
            if (legalHeir === 0) {
                this.dialogVisible = true
            } else {
                this.dialogVisible = false
            }
            let branchesNumberform = this.form.branchesNumber
            if (branchesNumberform === '') {
                branchesNumberform = 0
            }
            let tochiOku = this.getDataInputText(this.form.tochiOku)
            let tochiMan = this.getDataInputText(this.form.tochiMan)
            let kaokuOku = this.getDataInputText(this.form.kaokuOku)
            let kaokuMan = this.getDataInputText(this.form.kaokuMan)
            let yochokinOku = this.getDataInputText(this.form.yochokinOku)
            let yochokinMan = this.getDataInputText(this.form.yochokinMan)
            let yuukaSyoukenOku = this.getDataInputText(this.form.yuukaSyoukenOku)
            let yuukaSyoukenMan = this.getDataInputText(this.form.yuukaSyoukenMan)
            let sonotaOku = this.getDataInputText(this.form.sonotaOku)
            let sonotaMan = this.getDataInputText(this.form.sonotaMan)
            let saimuOku = this.getDataInputText(this.form.saimuOku)
            let saimuMan = this.getDataInputText(this.form.saimuMan)
            // this.disableLegalHeir()
            // UIから値を設定します。
            let tochSougaku = tochiOku * 100000000 + tochiMan * 10000
            let kaokuSougaku = kaokuOku * 100000000 + kaokuMan * 10000
            let yochokinSougaku = yochokinOku * 100000000 + yochokinMan * 10000
            let yuukaSyoukenSougaku = yuukaSyoukenOku * 100000000 + yuukaSyoukenMan * 10000
            let sonotaSougaku = sonotaOku * 100000000 + sonotaMan * 10000
            let saimu = saimuOku * 100000000 + saimuMan * 10000
            this.calculateTotalValue()
            // 財産の総額から、債務の総額を引きます。
            let isanSogaku = tochSougaku + kaokuSougaku + yochokinSougaku + yuukaSyoukenSougaku + sonotaSougaku - saimu
            let sozokunin = Number(this.form.legalHeir)
            if (Number.isNaN(sozokunin)) {
                sozokunin = 0
            }
            let haigusya = this.form.maritalStatus
            let zokugara = this.form.type
            let haiwari = this.form.acquisitionRatio.toString()
            let kazeiIsanSougaku = (isanSogaku) - (30000000 + 6000000 * sozokunin)
            // マイナスだったら0に
            if (kazeiIsanSougaku < 0) {
                kazeiIsanSougaku = 0
            }
            let haiKeigen = 0
            let haiTori = 0
            let koTori = 0
            let oyaTori = 0
            let kyoTori = 0
            let haiZei = 0
            let koZei = 0
            let oyaZei = 0
            let kyoZei = 0
            let sozokuzei = 0
            let kyoKasan = 0
            if (sozokunin === 0) {
                sozokuzei = this.zeikin(kazeiIsanSougaku) * 1.2 // 法定相続人が0人の場合も2割加算
            // haigusya あり selected
            } else if (haigusya === '60001') {
                // 配偶者有り
                switch (zokugara) {
                    // 子
                    case '59001':
                        haiTori = kazeiIsanSougaku / 2
                        koTori = (kazeiIsanSougaku / 2) / (sozokunin - 1)
                        haiZei = this.zeikin(haiTori)
                        koZei = this.zeikin(koTori)
                        break
                    // 父母
                    case '59002':
                        haiTori = kazeiIsanSougaku * 2 / 3
                        oyaTori = kazeiIsanSougaku / 3 / (sozokunin - 1)
                        haiZei = this.zeikin(haiTori)
                        oyaZei = this.zeikin(oyaTori)
                        break
                    // 兄弟姉妹
                    case '59003':
                        haiTori = kazeiIsanSougaku * 3 / 4
                        kyoTori = kazeiIsanSougaku / 4 / (sozokunin - 1)
                        haiZei = this.zeikin(haiTori)
                        kyoZei = this.zeikin(kyoTori)
                        break
                }
                if (zokugara) {
                    sozokuzei = haiZei + koZei * (sozokunin - 1) + oyaZei * (sozokunin - 1) + kyoZei * (sozokunin - 1)
                } else {
                    sozokuzei = this.zeikin(kazeiIsanSougaku / sozokunin) * sozokunin
                }
            } else if (haigusya === '60002') {
                // haigusya なし selected
                // 配偶者無し
                switch (zokugara) {
                    // 子
                    case '59001':
                        koTori = kazeiIsanSougaku / sozokunin
                        koZei = this.zeikin(koTori)
                        break
                    // 父母
                    case '59002':
                        oyaTori = kazeiIsanSougaku / sozokunin
                        oyaZei = this.zeikin(oyaTori)
                        break
                    // 兄弟姉妹
                    case '59003':
                        kyoTori = kazeiIsanSougaku / sozokunin
                        kyoZei = this.zeikin(kyoTori) * 1.2 // 兄弟姉妹の場合 2割加算
                        break
                }
                if (zokugara) {
                    sozokuzei = haiZei + koZei * sozokunin + oyaZei * sozokunin + kyoZei * sozokunin
                } else {
                    sozokuzei = this.zeikin(kazeiIsanSougaku / sozokunin) * sozokunin
                }
            }
            // 配偶者軽減額を計算
            if (haigusya === '60001') {
                switch (zokugara) {
                    // 子
                    case '59001':
                        haiTori = (isanSogaku) / 2
                        break
                    // 父母
                    case '59002':
                        haiTori = (isanSogaku) * 2 / 3
                        break
                    // 兄弟姉妹
                    case '59003':
                        haiTori = (isanSogaku) * 3 / 4
                        kyoKasan = sozokuzei * ((100 - haiwari) / 100) * 0.2
                        break
                }
                // hai_toriは、配偶者の法定相続割合による財産取得額
                if (haiTori > 160000000) {
                    if (haiTori > ((isanSogaku) / 100 * haiwari)) {
                        haiKeigen = sozokuzei * ((isanSogaku) / 100 * haiwari) / (isanSogaku)
                    } else {
                        haiKeigen = sozokuzei / (isanSogaku) * haiTori
                    }
                } else {
                    if (((isanSogaku) / 100 * haiwari) < 160000000) {
                        haiKeigen = sozokuzei * ((isanSogaku) / 100 * haiwari) / (isanSogaku)
                    } else {
                        haiKeigen = sozokuzei / (isanSogaku) * 160000000
                    }
                }
            }
            if (sozokunin > 0) {
                // 配偶者軽減額を差し引く 兄弟姉妹の2割加算分を足す
                sozokuzei = sozokuzei - haiKeigen + kyoKasan
            }
            // UIへ結果を表示
            if (!this.autoValidate()) {
                // 何もしない
                this.form.yenRequired = 0
                this.form.billionRequired = 0
            } else {
                this.form.billionRequired = ''
                this.form.yenRequired = '0'
                this.necessary = ''
                if ((isanSogaku) - 30000000 - 6000000 * sozokunin > 0) {
                        this.necessary = '必要'
                    } else {
                        this.necessary = '不要'
                    }
                    if (sozokunin < 2 && haigusya === 2) {
                        // 何もしない
                    } else {
                        if (sozokuzei >= 1000) {
                            if (sozokuzei >= 100000000) {
                                this.form.billionRequired = this.formatPrice(Math.floor(sozokuzei / 100000000, 0))
                            }
                            this.form.yenRequired = this.formatPrice(Math.ceil(sozokuzei / 10000, 0) - Math.floor(sozokuzei / 100000000, 0) * 10000)
                        }
                    }
            }
            this.totalYen()
        },
        calculateTotalValue () {
          const unitMan = 10000
          let tochiOku = this.getDataInputText(this.form.tochiOku)
          let kaokuOku = this.getDataInputText(this.form.kaokuOku)
          let yochokinOku = this.getDataInputText(this.form.yochokinOku)
          let yuukaSyoukenOku = this.getDataInputText(this.form.yuukaSyoukenOku)
          let sonotaOku = this.getDataInputText(this.form.sonotaOku)
          let saimuOku = this.getDataInputText(this.form.saimuOku)
          let oku = tochiOku + kaokuOku + yochokinOku + yuukaSyoukenOku + sonotaOku - saimuOku
          let tochiMan = this.getDataInputText(this.form.tochiMan)
          let kaokuMan = this.getDataInputText(this.form.kaokuMan)
          let yochokinMan = this.getDataInputText(this.form.yochokinMan)
          let yuukaSyoukenMan = this.getDataInputText(this.form.yuukaSyoukenMan)
          let sonotaMan = this.getDataInputText(this.form.sonotaMan)
          let saimuMan = this.getDataInputText(this.form.saimuMan)
          let man = tochiMan + kaokuMan + yochokinMan + yuukaSyoukenMan + sonotaMan - saimuMan
          this.originOku = tochiOku + kaokuOku + yochokinOku + yuukaSyoukenOku + sonotaOku
          this.originMan = tochiMan + kaokuMan + yochokinMan + yuukaSyoukenMan + sonotaMan
          let calculatedTotal = oku * unitMan + man
          let roundOku = calculatedTotal / unitMan
          oku = roundOku > 0 ? Math.floor(roundOku) : Math.ceil(roundOku)
          man = calculatedTotal - oku * unitMan
          this.form.billion01 = oku
          this.form.yen01 = man
        },
        validation () {
            let souzokunin = parseInt(this.form.legalHeir)
            let haigusha = parseInt(this.form.maritalStatus)
            if (souzokunin >= 2 && haigusha === 2) {
                this.form.billionRequired = ''
                this.form.yenRequired = ''
                this.necessary = ''
                return true
            } else {
                return false
            }
        },
        changType (val) {
            if (val === '60001' && this.form.acquisitionRatio === '') {
                this.form.acquisitionRatio = '50'
            }
            this.sumJudgmentRequired()
        },
        zeikin (val) {
            let zeikin = 0
            if (val <= 10000000) {
                zeikin = val * 0.1
            } else if (val <= 30000000) {
                zeikin = val * 0.15 - 500000
            } else if (val <= 50000000) {
                zeikin = val * 0.2 - 2000000
            } else if (val <= 100000000) {
                zeikin = val * 0.3 - 7000000
            } else if (val <= 200000000) {
                zeikin = val * 0.4 - 17000000
            } else if (val <= 300000000) {
                zeikin = val * 0.45 - 27000000
            } else if (val <= 600000000) {
                zeikin = val * 0.5 - 42000000
            } else if (val > 600000000) {
                zeikin = val * 0.55 - 72000000
            }
            return zeikin
        },
        totalYen () {
            this.showTotal = false
            let unitOcku = 100000000
            let unitMan = 10000
            let calculatedTotal = this.originOku * unitOcku + this.originMan * unitMan

            let rewardLand = 0
            let _this = this
            this.estimatesAddDtoPrivate.forEach(function (item, index) {
                if (item.quantity === _this.form.numberOfLand && item.categoryType === 'land') {
                    rewardLand = item.reward
                }
            })
            let rewardHeir = 0
            let maxReward = 0
            this.estimatesAddDtoPrivate.forEach(item => {
                if (item.reward > maxReward && item.categoryType === 'heir') {
                    maxReward = item.reward
                }
                if (item.quantity === parseInt(_this.form.legalHeir) && item.categoryType === 'heir') {
                    rewardHeir = item.reward
                }
            })
            if (parseInt(_this.form.legalHeir) > 4) {
                rewardHeir = maxReward
            }

            let baseReward = 0
            this.estimatesBaseDtoPrivate.forEach(function (item, index) {
                if (calculatedTotal >= item.amountFrom && calculatedTotal <= item.amountTo) {
                    baseReward = item.reward
                }
            })
            //　預金加算
            let brancheReward = 0
            const branchesNumber = parseInt(_this.form.branchesNumber)
            if (branchesNumber > 0) {
                brancheReward = branchesNumber * 20000
            }
            let totalYen = rewardLand + (rewardHeir / 100 * baseReward) + baseReward + brancheReward
            this.form.estimateSum = this.formatPrice(totalYen)
            this.registerData()
        },
        handleCloseDialog (val) {
            this.dialogVisible = val
        },
        autoValidate () {
            let check = true
            this.$refs['form'].validate((valid) => {
                check = valid
            })
            return check
        },
        handleCompute () {
            const estimateSum = this.deformatPrice(this.form.estimateSum)
            calculationtax.getConsumptionTax(estimateSum).then(response => {
                this.form.estimeteSumWithTax = this.formatPrice(+estimateSum + response.data.data)
                this.showTotal = true
            })
        },
        convertStrAndSumJudgmentRequired () {
            // 10進数の場合
            this.form.legalHeir = this.form.legalHeir.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
                return String.fromCharCode(
                    s.charCodeAt(0) - 65248
                )
            })

            // 16進数の場合
            this.form.legalHeir = this.form.legalHeir.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
                return String.fromCharCode(
                    s.charCodeAt(0) - 0xFEE0
                )
            })

            this.sumJudgmentRequired()
        },
        convertStrAndSumJudgmentRequiredBranchesNumber () {
            // 10進数の場合
            this.form.branchesNumber = this.form.branchesNumber.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
                return String.fromCharCode(
                    s.charCodeAt(0) - 65248
                )
            })

            // 16進数の場合
            this.form.branchesNumber = this.form.branchesNumber.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
                return String.fromCharCode(
                    s.charCodeAt(0) - 0xFEE0
                )
            })

            this.sumJudgmentRequired()
        }
    },
    created () {
        this.getItemData()
        this.fetchData()
        this.$bus.$on('refreshData', (data) => {
            if (this.$route.name === data) {
                this.fetchData()
            }
        })
        window.scroll(0, 0)
    },
    mounted () {
          if (isIE()) {
              this._$('.el-select input[type="text"]').css('pointer-events', 'none')
              this._$('.el-select input[type="text"]').on('focus', event => event.currentTarget.blur())
          }
    },
    updated () {
      if (this.showTotal && this.isScrollDown) {
        window.scrollTo(0, document.body.scrollHeight)
        this.isScrollDown = false
      }
    }
}
</script>
<style>
    @import './PFF-B-02.css';
    @import "../../../../assets/css/custom.css";
</style>
